import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { VideoThumbnail } from "../../types/cms";
import VideoPlayer from "./VideoPlayer";

export default function VideoQuickView({
  video,
  onClose,
}: {
  video: VideoThumbnail | null;
  onClose: () => void;
}) {
  useEffect(() => {
    if (!video) return;
    const onKey = (e: KeyboardEvent) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [video, onClose]);

  if (!video) return null;
  return (
    <div className="fixed inset-0 bg-black/60 flex justify-center items-center z-50 p-4" onClick={onClose}>
      <button onClick={onClose} className="absolute top-6 right-8 text-6xl text-neutral-50 select-none" aria-label="Close">
        ×
      </button>
      <div
        role="dialog"
        aria-modal="true"
        aria-label={video.title}
        className="w-full md:w-2/3 bg-neutral-50 p-2 pb-4 rounded-md relative flex flex-col gap-4"
        onClick={(e) => e.stopPropagation()}
      >
        <VideoPlayer video={video} autoPlay />
        <div className="flex flex-wrap items-center justify-between gap-3 px-2">
          <div className="min-w-0">
            <p className="font-bold truncate">{video.title}</p>
            <p className="text-sm text-neutral-600 truncate">
              {video.videoFor?.name}
              {video.producedBy?.id ? ` · by ${video.producedBy.name}` : ""}
            </p>
          </div>
          <Link to={`/video/${video.id}`} className="px-4 py-2 bg-black text-white rounded-full w-max">
            View video page
          </Link>
        </div>
      </div>
    </div>
  );
}
